// Sticky product-column widths for spreadsheet-style grids.
// Bottom Up plan grids (by-month + by-day) use a narrower column.
export const PLAN_PRODUCT_COL_WIDTH = 220;
// Inventory calendar/stock matrix and Wholesale forecast grids.
export const PRODUCT_COL_WIDTH = 260;
